import React from 'react';
import type { LoggedInUser } from '../../../types/auth.types';

const UserContext = React.createContext<LoggedInUser>(null);

export const UserConsumer = UserContext.Consumer;
export const UserProvider = UserContext.Provider;

export default UserContext;
